import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import { CategoriaSal } from '../models';




@Injectable({
    providedIn: "root"
})
export class CategoriaSalService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}CategorieSal/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<any>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<CategoriaSal[]>(
            `${this.apiUrl}`            
        );
    }

    insert(s: CategoriaSal) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: CategoriaSal) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:CategoriaSal){
        if (!s.id)return this.insert(s);
        return this.update(s);
    }

}
